// hooks/useBodyLockScroll.js
import { useEffect } from "react";

const getLockState = () => {
  if (typeof window === "undefined") return null;
  if (!window.__bodyLockState) {
    window.__bodyLockState = {
      count: 0,
      prev: null,
      scrollY: 0,
    };
  }
  return window.__bodyLockState;
};

export default function useLockBodyScroll(isLocked) {
  useEffect(() => {
    if (typeof window === "undefined" || !isLocked) return;

    const html = document.documentElement;
    const body = document.body;
    const S = getLockState();
    if (!S) return;

    // Nur beim ersten Lock Styles sichern + anwenden
    if (S.count === 0) {
      S.prev = {
        htmlOverscroll: html.style.overscrollBehavior,
        htmlScrollBehavior: html.style.scrollBehavior,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyWidth: body.style.width,
        bodyOverflowY: body.style.overflowY,
        bodyTouchAction: body.style.touchAction,
      };
      S.scrollY = window.scrollY || window.pageYOffset || 0;

      html.style.overscrollBehavior = "none";
      html.style.scrollBehavior = "auto";
      body.style.position = "fixed";
      body.style.top = `-${S.scrollY}px`;
      body.style.width = "100%";
      body.style.overflowY = "scroll"; // stabilisiert Layoutbreite
      body.style.touchAction = "none"; // iOS Touch-Scroll blocken
    }

    S.count += 1;

    return () => {
      const S2 = getLockState();
      if (!S2) return;

      S2.count = Math.max(0, S2.count - 1);

      // Erst wenn keine weitere Modal-Instanz offen ist → wirklich entsperren
      if (S2.count === 0 && S2.prev) {
        const p = S2.prev;
        html.style.overscrollBehavior = p.htmlOverscroll || "";
        html.style.scrollBehavior = p.htmlScrollBehavior || "";
        body.style.position = p.bodyPosition || "";
        body.style.top = p.bodyTop || "";
        body.style.width = p.bodyWidth || "";
        body.style.overflowY = p.bodyOverflowY || "";
        body.style.touchAction = p.bodyTouchAction || "";
        window.scrollTo(0, S2.scrollY || 0);
        S2.prev = null;
      }
    };
  }, [isLocked]);
}
